export default ({
  theme,
  attach,
  nest,
  APP_BAR,
  LIST_ITEM,
  TOOLBAR,
  TEXT
}) => ({
  MuiAppBar: {
    root: {
      [attach(APP_BAR.root)]: {
        backgroundImage:
          'linear-gradient(30deg, #2B4358, #10678B, #1a5e86, #13808F)',
        position: 'relative',
        margin: 'auto',
        width: '100%',
        color: 'white',
        zIndex: 1
      }
    }
  },
  MuiToolbar: {
    root: {
      [attach(TOOLBAR.topnavigation)]: {
        backgroundColor: theme.palette.primary.dark,
        minHeight: 30,
        margin: 'auto',
        width: '99%'
      }
    },
    dense: {
      minHeight: 10
    },
    gutters: {
      padding: '0 !imporant'
    }
  }
});
